import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";
import { useTranslation } from "react-i18next";

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, logout, user } = useAuth();
  const { t, i18n } = useTranslation();
  const active = (path, { startsWith = false } = {}) => {
    const match = startsWith
      ? location.pathname.startsWith(path)
      : location.pathname === path;
    return match ? "text-blue-500 font-semibold" : "text-gray-700";
  };

  const changeLanguage = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  if (!isAuthenticated) {
    return (
      <nav className="flex items-center justify-between bg-gray-100 p-4 shadow-sm">
        <h1 className="text-lg font-bold text-gray-800">{t("nav.title")}</h1>
        <div className="flex items-center gap-3">
          <select
            value={i18n.language}
            onChange={changeLanguage}
            className="border rounded px-2 py-1 text-sm bg-white"
            aria-label={t("nav.language")}
          >
            <option value="fi">FI</option>
            <option value="en">EN</option>
          </select>
          <Link className={active("/login")} to="/login">
            {t("nav.login")}
          </Link>
        </div>
      </nav>
    );
  }

  return (
    <nav className="flex items-center justify-between bg-gray-100 p-4 shadow-sm">
      <h1 className="text-lg font-bold text-gray-800">{t("nav.title")}</h1>
      <div className="flex gap-6 items-center">
        <Link className={active("/")} to="/">
          {t("nav.links.corporate")}
        </Link>
        <Link className={active("/chart")} to="/chart">
          {t("nav.links.daily")}
        </Link>
        <Link className={active("/analysis")} to="/analysis">
          {t("nav.links.analysis")}
        </Link>
        {user?.role === "admin" && (
          <Link className={active("/prices")} to="/prices">
            {t("nav.links.stats")}
          </Link>
        )}
        <Link className={active("/trends")} to="/trends">
          {t("nav.links.trends")}
        </Link>
        <Link className={active("/help/compare", { startsWith: true })} to="/help/compare">
          {t("nav.links.help")}
        </Link>
        {user?.role === "admin" && (
          <Link className={active("/admin", { startsWith: true })} to="/admin">
            {t("nav.links.admin")}
          </Link>
        )}
        <select
          value={i18n.language}
          onChange={changeLanguage}
          className="border rounded px-2 py-1 text-sm bg-white"
          aria-label={t("nav.language")}
        >
          <option value="fi">FI</option>
          <option value="en">EN</option>
        </select>
        <button
          onClick={async () => {
            await logout();
            navigate("/login", { replace: true });
          }}
          className="text-sm text-gray-600 hover:text-red-500"
        >
          {t("nav.logout")}
        </button>
      </div>
    </nav>
  );
}
